<template>
  <v-row>
    <v-col cols="12">
      <h2>{{ $t('no_deposit.head') }}</h2>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title> {{ $t('no_deposit.head_list') }} </v-card-title>
        <v-card-actions class="pb-0 d-flex align-start">
          <v-row no-gutters>
            <span>
              <v-select v-model="type_id" :label="$t('report_bonus.date_from')" :items="types" item-text="label" outlined
                dense />
              <!-- <select-input label="สถานะ" /> -->
            </span><div  style="margin-left: 5px;"></div>
            <v-btn color="primary" @click="getNoDeposit" class=""> {{ $t("search") }} </v-btn><div  style="margin-left: 5px;"></div>
            <v-btn color="warning" @click="preloadExportCsv" class="">{{ $t("user.export_excel") }}</v-btn>
           </v-row>
        </v-card-actions>
        <v-card-actions class="pt-0">
          <v-data-table mobile-breakpoint="0" style="width: 100%" :headers="headers" :no-data-text="$t('not_found')"
            :no-results-text="$t('not_found')" :options.sync="pagination" :server-items-length="pagination.totalItems"
            :items-per-page="pagination.rowsPerPage" :loading="loading" :page.sync="pagination.currentPage" :footer-props="{
              'items-per-page-options': [10, 25, 30, 40, 50],
            }" :items="members">

            <template v-slot:[`item.amount`]="{ item }">
              {{ item.amount | currency }}
            </template>
          </v-data-table>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import DatePickerInput from '@/components/input/DatePickerInput.vue'
import SelectInput from '@/components/input/SelectInput.vue'
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import store from '@/store';
export default {
  components: {
    DatePickerInput,
    SelectInput,
  },
  data() {
    return {
      valPartner: "พันธมิตร",
      valType: "ทั้งหมด",
      headers: [
        {
          text: this.$t('no_deposit.header1'),
          value: 'phone',
          width: '200px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('no_deposit.header2'),
          value: 'name',
          width: '200px',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('no_deposit.header3'),
          value: 'date',
          width: '200px',
          align: 'center',
          sortable: false,
        },
      ],
      members: [],
      types: ['ย้อนหลัง 1-7 วัน','ย้อนหลัง 8-15 วัน','ย้อนหลัง 16-30 วัน'],
      type_id:'ย้อนหลัง 1-7 วัน',
      loading: false,
      pagination: {
        currentPage: 1,
        rowsPerPage: 25,
        totalItems: 0,
      },
      total: 0,
      dummy: true,
    }
  },
  watch: {
    pagination: {
      async handler(newValue, oldValue) {
        let cont = false
        if (oldValue.page !== newValue.page) cont = true
        if (oldValue.itemsPerPage !== newValue.itemsPerPage) cont = true
        if (oldValue.sortBy !== newValue.sortBy) cont = true
        if (oldValue.sortDesc !== newValue.sortDesc) cont = true
        // await this.getBonus(newValue.page, newValue.itemsPerPage, this.$refs.startDate.value, this.$refs.endDate.value, this.searchData, this.valPartner, this.valType)
        if (cont) await this.getNoDeposit(newValue.page, newValue.itemsPerPage)
        if (cont) await this.getNoDeposit(newValue.page, newValue.itemsPerPage)
      },
      deep: true,
    },
  },
  async created() {
    this.addLogPage()
  },
  methods: {
    async addLogPage() {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(res =>
          data = {
            ip: res.data.ip,
            name: 'รายงานฝากแรก',
            url: window.location.href,
            detail: 'รายงานฝากแรก',
            admin: userSystem.name ? userSystem.name : '',
          }
        )
        await this.$store.dispatch('addLogPage', data)
      } catch (e) {
        // if (!e.message.includes('Unexpected token') || !e?.includes('Unexpected token') || !e.message.includes('Unexpected identifier')) {
        //   this.$swal.fire({
        //     icon: 'error',
        //     title: e.message,
        //   })
        // }
      }
    },
    async getNoDeposit(page, row) {
      this.loading = true
      this.members = []
      let typeSelectId=''
      if(this.type_id===this.types[0]){
          typeSelectId=1;
      }else if(this.type_id===this.types[1]){
          typeSelectId=2;
      }else{
        typeSelectId=3;
      }
      // console.log(valArr);
      let rs = await this.$store.dispatch('getAccountingNoDeposit', {
        page: this.pagination.currentPage,
        rows: this.pagination.rowsPerPage,
        type:typeSelectId
      })
      this.pagination.totalItems = rs.count
      this.totalRows = rs.count ? Number(rs.count) : ''
      rs.data.forEach(element => {
        this.members.push({
          phone: element.phone,
          name: element.name,
          date: element.createdat ? moment(element.createdat).format('YY-MM-DD HH:mm') : '',
        })
      })
      this.loading = false
    },
    async preloadExportCsv() {
      await this.addLogExportCSV(true)
      //////// get logExportData ////////
      let logExportData;
      const userSystem = store.getters.getuserInfo
      await axios.get('https://api.ipify.org?format=json').then(res =>
        logExportData = {
          ip: res.data.ip,
          exportPage: 'บัญชี - รายงานสมาชิกไม่ฝาก',
          url: window.location.href,
          detail: 'ระบบบัญชี',
          admin: userSystem.name ? userSystem.name : '' ? userSystem.name : '',
        }
      )

      this.$swal({
        title: `Secure code | รายงาน${logExportData.exportPage}`,
        input: 'password',
        // inputAttributes: {
        //   inputmode: 'numeric',
        //   pattern: '[0-9]*',
        //   maxlength: 6,
        // },
        inputValidator: value => {
          if (!value) {
            return 'โปรดกรอก Secure code'
          }
          // if (value && value.length !== 6) {
          //   return 'โปรดกรอกให้ครบ 6 หลัก'
          // }
        },
        inputPlaceholder: 'ใส่รหัสที่นี่...',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ออก',
      }).then(async result => {
        if (result.isConfirmed) {
          const pin = result.value
          let enterSecureData = {
            ...logExportData,
            keyCheck: pin
          }
          this.loading = true
          let resEnterSecureData = await this.$store.dispatch('checkLogEnterSecure', enterSecureData)
          if (resEnterSecureData && resEnterSecureData.secure) {
            this.exportCsv()
          } else {
            this.$swal.fire('ไม่สามารถ download ได้ เนื่องจากรหัส PIN ไม่ถูกต้อง', '', 'error')
          }
          this.loading = false
        }
      })
    },
    async exportCsv() {
      this.$swal.fire({
        html: this.$t("processing"),
        timerProgressBar: true,
        didOpen: () => { this.$swal.showLoading() }
      })

      let fileName = `${this.$t("no_deposit.file_name")}_${moment(new Date()).format('YYYY-MM-DD_HH-mm')}`
      const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const wscols = [
        { wch: 15 },
        { wch: 25 },
        { wch: 10 },
        { wch: 10 },
        { wch: 20 },
        { wch: 20 },
        { wch: 15 },
      ];
      let statementlist = []
      let typeSelectId=''
      if(this.type_id===this.types[0]){
          typeSelectId=1;
      }else if(this.type_id===this.types[1]){
          typeSelectId=2;
      }else{
        typeSelectId=3;
      }
      let rs = await this.$store.dispatch('getAccountingNoDeposit', {
        page: 1,
        rows: 1000000,
        type: typeSelectId,
      })
      // console.log(rs.data);
      rs.data.forEach(element => {
        statementlist.push({
          phone: element.phone,
          name: element.name,
          date: element.createdat ? moment(element.created_at).format('YYYY-MM-DD HH:mm') : '',
        })
      })
      let ws = XLSX.utils.json_to_sheet(statementlist);
      ws['!cols'] = wscols;
      const wb = { Sheets: { AccoutingNoDepoit: ws }, SheetNames: ["AccoutingNoDepoit"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);

      // add log admin export
      await this.addLogExportCSV()
      this.$swal.close()
    },
    async addLogExportCSV(isClick=false) {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(res =>
          data = {
            ip: res.data.ip,
            exportPage: 'บัญชี',
            url: window.location.href,
            detail: 'ระบบรายงานสมาชิกไม่ฝาก',
            admin: userSystem.name ? userSystem.name : '' ? userSystem.name : '',
            isClick: isClick,
          }
        )
        await this.$store.dispatch('addLogExportCSV', data)
      } catch (e) {
        if (!e.message.includes('Unexpected token') || !e?.includes('Unexpected token') || !e.message.includes('Unexpected identifier')) {
          this.$swal.fire({
            icon: 'error',
            title: e.message,
          })
        }
      }
    },
    formatDateYYYY(date) {
      const dateConv = date?.length > 8 ? date.substring(2) : date
      return moment(`20${dateConv}`).format('YYYY-MM-DD')
    },
  },
}
</script>
<style scoped>
@import '../../styles/custom.css';
</style>
